<template>
  <!-- <el-dialog
    title="Chi tiết đặt phòng"
    :visible="visible"
    :close-on-click-modal="false"
    width="800px"
    @close="close"
  > -->
  <div>
    <GridVx
      ref="dailyPriceTable"
      :columns="daysTableColumns"
      :auto-size-cell="true"
      :context="context"
      :rows="tableData"
    >
    </GridVx>
  </div>
  <!-- </el-dialog> -->
</template>
<script>
import {
  CellRenderCheckbox,
  CellRenderCurrencyInput,
  CellRenderDeleteIcon,
  CellRenderSelect,
  CellRenderSelectWithSearchTable,
  CellRenderTextInput
} from '@/utils/cellRenders'
import { getAllCurrencyApi } from '@/api/common/currency'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderTextInput,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelect,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelectWithSearchTable,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderDeleteIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCurrencyInput
  },
  props: {
    tableData: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      context: null,
      daysTableColumns: [
        {
          headerName: 'Ngày',
          field: 'date'
        },
        {
          headerName: 'Tự nhập',
          field: 'is_self_price',
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCheckbox',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Giá',
          field: 'price',
          cellRenderer: 'CellRenderCurrencyInput',
          readOnly: false
        },
        // {
        //   headerName: 'Tiền tệ',
        //   field: 'currency_id',
        //   cellRenderer: 'CellRenderSelect',
        //   cellRendererParams: params => {
        //     return {
        //       // allTranPageOptions
        //       options: this.currencyOptions,
        //       refName: 'currency_id'
        //     }
        //   }
        // },
        // {
        //   headerName: 'NETT',
        //   field: 'nett',
        //   headerClass: 'header-cell-center',
        //   cellRenderer: 'CellRenderCheckbox',
        //   cellClass: 'grid-cell-centered'
        // },
        {
          headerName: 'Ghi chú',
          field: 'note',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: 'Giảm giá (%)',
          field: 'percent_discount',
          cellRenderer: 'CellRenderCurrencyInput'
        },
        {
          headerName: 'Giảm giá (Tiền)',
          field: 'amount_discount',
          cellRenderer: 'CellRenderCurrencyInput'
        },
        {
          headerName: 'Lý do giảm giá',
          field: 'discount_reason',
          cellRenderer: 'CellRenderTextInput'
        }
      ],
      daysTableData: [],
      currencyOptions: [],
      priceCodeOptions: [],
      breakfastCodeOptions: [],
      discountReasonOptions: []
    }
  },
  async mounted() {
    await Promise.all([this.getAllCurrency()])
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  methods: {
    async getAllCurrency() {
      await getAllCurrencyApi().then(response => {
        this.currencyOptions = response.data.map(item => ({
          label: item.code,
          value: item.id
        }))
      })
    },
    changeCheckbox(colName, params, value) {
      this.$emit('updateDailyPrice', colName, params, value)
    },
    changeCurrencyInput(params, value, colName) {
      this.$emit('updateDailyPrice', colName, params, value)
    },
    SelectInputChange(colName, params, value) {
      this.$emit('updateDailyPrice', colName, params, value)
    },
    textInputChange(params, value, colName) {
      this.$emit('updateDailyPrice', colName, params, value)
    }
  }
}
</script>
